import * as o from "react";
import e from "../lib/IconBase.es.js";
import r from "../defs/ClockCountdown.es.js";
const t = o.forwardRef((n, c) => /* @__PURE__ */ o.createElement(e, { ref: c, ...n, weights: r }));
t.displayName = "ClockCountdownIcon";
const s = t;
export {
  s as ClockCountdown,
  t as ClockCountdownIcon
};
